import React, { useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import DataTable from "../DataTable/DataTable";
import { IoClose } from "react-icons/io5";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "../Loading";
import Discrepancy from "./Discrepancy";
import { useErrorToast } from "../../hooks/useErrorToast";

const CreditNoteDetail = ({ open, setOpen, data, invoiceNo, invoice = [] }) => {
    const showError = useErrorToast();
  const [discrepancyModal, setDiscrepancyModal] = useState(false);
  const [discrepancyData, setDiscrepancyData] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState({});
  const [loadingFull, setLoadingFull] = useState(false);
  const navigate = useNavigate();

  // Function to close the modal
  const handleClose = () => setOpen(false);

const columns = [
  {
    field: "doc_id",
    headerName: "Doc ID",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "original_invoice",
    headerName: "Original Invoice ID",
    width: 150,
    renderCell: (params) =>
      params.value ? (
        <Tooltip title="View invoice detail">
          <span
            onClick={() => fetchInvoiceDetails(params.value)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {params.value}
          </span>
        </Tooltip>
      ) : (
        "N/A"
      ),
  },
  {
    field: "service_name",
    headerName: "Service Name",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "original_invoice_date",
    headerName: "Original Invoice Date",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "amount_usd",
    headerName: "Amount(USD)",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "charge_type",
    headerName: "Charge Type",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "charge_period",
    headerName: "Charge Period",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "contract_sof_number",
    headerName: "Contract Sof Number",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "currency",
    headerName: "Currency",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
{
  field: "discounts_promotions",
  headerName: "Discounts Promotions",
  width: 150,
  renderCell: (params) => {
    return params.value === 0 || params.value === 0.0
      ? 0
      : params.value || "N/A";
  },
},

  {
    field: "doc_date",
    headerName: "Doc date",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "location_id",
    headerName: "Location Id",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "location",
    headerName: "Location",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "page_number",
    headerName: "Page Number",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "pip_port_description",
    headerName: "Pip Port Description",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "taxes_surcharges",
    headerName: "Taxes Surcharges",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "total_usd",
    headerName: "Total Amount",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
  {
    field: "conversion_rate",
    headerName: "Conversion Rate",
    width: 150,
    renderCell: (params) => {
      const val = params.value;
      if (val === null || val === undefined || val === "N/A" || val === "") return "N/A";
      const num = Number(val);
      if (isNaN(num)) return val;
      const formatted = parseFloat(num.toFixed(3)).toString();
      return (
        <Tooltip title={String(val)} arrow placement="top">
          <span style={{ cursor: "pointer", borderBottom: "1px dashed #7C2EA0" }}>
            {formatted}
          </span>
        </Tooltip>
      );
    }
  },
  {
    field: "converted_total_usd",
    headerName: "Total USD",
    width: 150,
    renderCell: (params) => params.value || "N/A",
  },
];

  const fetchInvoiceDetails = async (invId) => {
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      let response = await axios.get(
        `${process.env.REACT_APP_URL}/get-discrepancy/${invId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      let data = response.data.data.map((el, index) => {
        return {
          ...el,
          id: index,
          service_name_y: el.service_name_y || el.service_name_x,
          amount: el.amount ? parseInt(el.amount).toFixed(2) : 0,
          location_id_y: el?.location_id_y || el?.location_id_x,
        };
      });
      setDiscrepancyData(data);
      setDiscrepancyModal(true);
      let invDetail = invoice.find((el) => el.invoice_id === invId);
      setSelectedColumn(invDetail);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(
        //   error.response.data.message ||
        //     "Something went wrong. Please try again."
        // );
        showError(error?.response?.data?.message || "Something went wrong. Please try again.");
      }
    } finally {
      setLoadingFull(false);
    }
  };

  const handleDownloadCSV = () => {
    const csvRows = [];
    const headers = [
      "Doc ID",
      "Original Invoice ID",
      "Service Name",
      "Original Invoice Date",
      "Amount",
      "Amount(USD)",
      "Charge Type",
      "Charge Period",
      "Contract Sof Number",
      "Currency",
      "Discounts Promotions",
      "Doc date",
      "Location Id",
      "Location",
      "Page Number",
      "Pip Port Description",
      "Taxes Surcharges",
      "Total Amount",
      "Conversion Rate",
      "Total (USD)",
    ];
    csvRows.push(headers.join(","));

    data?.forEach((invoice) => {
      const row = [
        invoice.doc_id || "N/A",
        invoice.original_invoice || "N/A",
        invoice.service_name || "N/A",
        invoice.original_invoice_date || "N/A",
        invoice.amount || "N/A",
        invoice.amount_usd || "N/A",
        invoice.charge_type || "N/A",
        invoice.charge_period || "N/A",
        invoice.contract_sof_number || "N/A",
        invoice.currency || "N/A",
        invoice.discounts_promotions || "N/A",
        invoice.doc_date || "N/A",
        invoice.location_id ||
          invoice.location_id_y ||
          invoice.location_id_x ||
          "N/A",
        invoice.location || "N/A",
        invoice.page_number || "N/A",
        invoice.pip_port_description || "N/A",
        invoice.taxes_surcharges || "N/A",
        invoice.total_usd ? `${invoice.currency} ${invoice.total_usd}` : "N/A",
        invoice?.conversion_rate || "N/A",
        invoice?.converted_total_usd || "N/A",
      ].map((value) => `"\t${String(value).replace(/"/g, '""')}"`);
      csvRows.push(row.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Credit_Note_Details_${invoiceNo}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      {loadingFull && <Loading />}
      <Modal
      style={{ zIndex: 9 }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "90%",
            height: "73%",
            maxWidth: "1200px",
            borderRadius: 2,
            overflowY: "auto",
            zIndex: 9,
          }}
        >
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography
                id="modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: "24px" }}
              >
                Credit Note Details
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <button
                  onClick={handleDownloadCSV}
                  style={{
                    background: "#4CAF50",
                    color: "#fff",
                    padding: "10px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Download CSV
                </button>
                <IoClose
                  size={24}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
            </div>
            <DataTable columns={columns} rows={data} />
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "20px",
              }}
            >
              <Button
                onClick={handleClose}
                style={{
                  flex: 1,
                  fontSize: "18px",
                  background: "#7C2EA0",
                  color: "white",
                  padding: "12px",
                }}
              >
                Close
              </Button>
            </div> */}
          </>
        </Box>
      </Modal>
      <Discrepancy
        open={discrepancyModal}
        setOpen={setDiscrepancyModal}
        discrepancyData={discrepancyData}
        invoiceNo={invoiceNo}
        selectedColumn={selectedColumn}
      />
    </div>
  );
};

export default CreditNoteDetail;
